module.exports = __webpack_public_path__ + "components/rewards/treads-and-trails/static/logo-df49116519924a661e03b99c68b74102.webp";